import { FC } from 'react';

type Props = {
  width?: number;
  text: string;
};
const EllipsisText: FC<Props> = ({ width = 7, text }) => {
  return (
    <p
      style={{
        maxWidth: `${width}rem`,
        minWidth: 1,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      }}
      title={text}
    >
      {text}
    </p>
  );
};

export default EllipsisText;
